module.exports = __webpack_public_path__ + "img/am.ff6f723.png";